import { render, staticRenderFns } from "./ProjectMaterialsAndPricesTableItem.vue?vue&type=template&id=41d6f991&scoped=true&"
import script from "./ProjectMaterialsAndPricesTableItem.vue?vue&type=script&lang=js&"
export * from "./ProjectMaterialsAndPricesTableItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMaterialsAndPricesTableItem.vue?vue&type=style&index=0&id=41d6f991&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d6f991",
  null
  
)

export default component.exports